import { Flex, SimpleGrid } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import Layout from "components/Layout";
import { toaster } from "components/ui/toaster";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "services/api";

function DurationManage() {
  const [isLoading, setIsLoading] = useState(false);
  // const [list, setList] = useState([]);
  // const [selectedItem, setSelectedItem] = useState();
  // const [activePage, setActivePage] = useState(1);
  // const [searchTxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);

  const [durationTypeDD, setDurationTypeDD] = useState([]);
  const [durationtype, setDurationtype] = useState();
  const [durationvalue, setDurationvalue] = useState();

  const ismobile = useCheckMobileScreen();
  const navigate = useNavigate();
  const location = useLocation();

  const action = location.state?.action;
  const itemData = location.state?.data;

  const onNew = async () => {
    setIsLoading(true);
    const res = await api.addDuration({
      durationtype,
      active: true,
      hide: false,
      durationvalue,
    });

    setIsLoading(false);
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      navigate("/duration", {
        state: {},
      });
    }
  };

  const onSave = async () => {
    setIsLoading(true);
    const res = await api.updateDuration({
      durationtype,
      active: true,
      hide: false,
      durationvalue,
      durationid: itemData?.durationid,
    });
    setIsLoading(false);

    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      navigate("/duration", {
        state: {},
      });
    }
  };

  const onChangeDurationDD = (data) => {
    console.log("vvvvvv", data?.list[0]?.selected);
    setDurationTypeDD(data?.list ? [...data?.list] : []);
    setDurationtype(data?.item?.label || "");
  };

  const getDurationTypeDD = (data) => {
    let index;
    let item;
    let list = [
      {
        id: "Months",
        label: "Months",
        value: "Months",
        data: {
          durationtype: "Months",
        },
      },
    ];
    // item = list[0];
    // index = 0;

    if (data?.default && list && list[0]) {
      list = list?.map((a, i) => {
        if (a?.data?.durationtype === data?.default) {
          index = i;
          a.selected = true;
          item = a;
        } else {
          a.selected = false;
        }
        return a;
      });
    }

    onChangeDurationDD({
      index,
      item,
      list,
    });
  };

  useEffect(() => {
    if (itemData?.durationvalue) {
      setDurationvalue(itemData?.durationvalue);
    }
    getDurationTypeDD({ default: itemData?.durationtype });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Duration"} isLoading={isLoading} />

      <Layout>
        <Flex
          flex={1}
          // maxW={"26rem"}
          direction={"column"}
          overflow={"scroll"}
          gap={"0.6rem"}
          justifyContent={"space-between"}
        >
          <SimpleGrid columns={ismobile ? 1 : 1} columnGap="1rem" rowGap="1rem">
            <InputComp
              type={"number"}
              label={"Duration"}
              value={durationvalue}
              onChange={setDurationvalue}
              required={true}
            />
            <InputComp
              type="dropdown"
              label={"Type"}
              items={durationTypeDD}
              onChange={onChangeDurationDD}
              // placeholder={"Select Branch"}
              required={true}
            />
          </SimpleGrid>
        </Flex>
      </Layout>
      <Flex flexFlow={"wrap"} mt={"1rem"} gap={"1rem"} alignSelf={"end"}>
        {action === "duration-edit" ? (
          <ButtonComp
            label="Save"
            onClick={onSave}
            keyname={"save"}
            disabled={isLoading}
          />
        ) : (
          <ButtonComp
            label="Add"
            onClick={onNew}
            keyname="add"
            disabled={isLoading}
          />
        )}
      </Flex>
    </Flex>
  );
}

export default DurationManage;
